import { lazy, Suspense, useMemo } from 'react';

export type IconName =
  | 'Warranty'
  | 'Cross'
  | 'Alert'
  | 'Check'
  | 'SideBarToggle'
  | 'Arrow'
  | 'Car'
  | 'Motorcycle'
  | 'Commercial'
  | 'Calendar'
  | 'Export'
  | 'NewAds'
  | 'Km'
  | 'Lock'
  | 'Max'
  | 'Min'
  | 'Lock'
  | 'Suggested'
  | 'Time'
  | 'Warranty'
  | 'Cross'
  | 'Calendar'
  | 'Clock'
  | 'PriceUp'
  | 'SearchPlus'
  | 'PriceDown';

export type IconSvgProps = {
  size?: number;
  color?: string;
  width?: string;
};

type IconProps = IconSvgProps & {
  iconName: IconName;
  color?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Icon = ({ iconName, color = 'red', size = 14, ...rest }: IconProps): JSX.Element => {
  const loadComponent = (name: IconName): React.LazyExoticComponent<React.ComponentType<IconSvgProps>> =>
    lazy(() => import(`./icons/${name}.tsx`));

  const Component = useMemo(() => loadComponent(iconName), []);

  return (
    <Suspense fallback={null}>
      <Component color={color} size={size} {...rest} />
    </Suspense>
  );
};
